import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import AuditProperties from './AuditProperties';
import { formatHours, parseShortDateWithTime, parseShortDateTime } from '../../../../utils/dates';

export default function TreatmentInstanceDetails({ instances }) {
  const mapActivities = instance => {
    return (
      <div className="activities-table-wrapper">
        <div className="activities-table-head">
          <Typography variant="h6" gutterBottom>
            Related Activities
          </Typography>
          <Grid container>
            <Grid item xs={6} sm={6}>
              <p>Activity name</p>
            </Grid>
            <Grid item xs={2} sm={2}>
              <p>Duration</p>
            </Grid>
            <Grid item xs={2} sm={2}>
              <p>RAG status</p>
            </Grid>
            <Grid item xs={2} sm={2}>
              <p>Required grade</p>
            </Grid>
          </Grid>
        </div>
        <div className="content">
          <Box>
            <Grid container spacing={0}>
              {instance.activities.map(activity => (
                <Grid item container xs={12} sm={12} key={`activity_${activity.id}`} className="info-wrapper">
                  <Grid item xs={6} sm={6}>
                    {activity.name}
                  </Grid>
                  <Grid item xs={2} sm={2}>
                    {formatHours(activity.duration)}
                  </Grid>
                  <Grid item xs={2} sm={2}>
                    {activity.ragStatus.name}
                  </Grid>
                  <Grid item xs={2} sm={2}>
                    {activity.band.name}
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Box>
        </div>
      </div>
    );
  };

  const mapInstanceData = instance => {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Instance Details
        </Typography>
        <List className="list-underline">
          <ListItem key={'org_unit'}>
            <ListItemText primary="Organization Unit" />
            <span className="divider" />
            <ListItemText secondary={instances[0].orgUnit.name} />
          </ListItem>
          <ListItem key={'occurence'}>
            <ListItemText primary="Instance occurence" />
            <span className="divider" />
            <ListItemText secondary={parseShortDateTime(instance.occurrence)} />
          </ListItem>
          <ListItem key={'is_specific_time'}>
            <ListItemText primary="Is specific time" />
            <span className="divider" />
            <ListItemText secondary={String(instance.isSpecificTime ? 'Yes' : 'No')} />
          </ListItem>
          <Typography variant="h6" gutterBottom style={{ paddingTop: '10px' }}>
            Time Slots
          </Typography>
          {instance.timeSlots.map(timeSlot => (
            <List key={`${timeSlot.from}_${timeSlot.to}`}>
              <ListItem key={`from_${timeSlot.from}`}>
                <ListItemText primary="From" />
                <span className="divider" />
                <ListItemText secondary={parseShortDateWithTime(timeSlot.from)} />
              </ListItem>
              {!instance.isSpecificTime && (
                <ListItem key={`from_${timeSlot.to}`}>
                  <ListItemText primary="To" />
                  <span className="divider" />
                  <ListItemText secondary={parseShortDateWithTime(timeSlot.to)} />
                </ListItem>
              )}
            </List>
          ))}
        </List>
        {instance.auditEntryProperties && <AuditProperties props={instance.auditEntryProperties} />}
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {instances && (
        <div>
          <div className="clinician-info-box"> {instances.map(mapInstanceData)}</div>
          <div className="clinician-info-box">{instances[0].activities && mapActivities(instances[0])}</div>
        </div>
      )}
    </React.Fragment>
  );
}
